import { createSelector, MemoizedSelector } from '@ngrx/store';
import { CalculatorItem } from '@product/const';
import { StateUtils } from '@spartacus/core';
import { ProductState, StateWithProduct } from '../product-state';
import { getCustomProductState } from './feature.selector';

type CalculatorsState = ProductState['calculatorList'];
type CalculatorResultState = ProductState['calculatorResult'];

export const getCalculatorsState: MemoizedSelector<StateWithProduct, CalculatorsState> = createSelector(
  getCustomProductState,
  (state: ProductState) => state.calculatorList,
);

export const getCalculatorResult: MemoizedSelector<StateWithProduct, CalculatorResultState> = createSelector(
  getCustomProductState,
  (state: ProductState) => state.calculatorResult,
);

export const getCalculators = (
  productCode: string,
): MemoizedSelector<StateWithProduct, StateUtils.LoaderState<CalculatorItem[]>> =>
  createSelector(getCalculatorsState, (state: CalculatorsState) =>
    StateUtils.entityLoaderStateSelector<CalculatorItem[]>(state, productCode),
  );

export const getCalculatorsValue = (code: string): MemoizedSelector<StateWithProduct, CalculatorItem[]> =>
  createSelector(getCalculatorsState, (state) => StateUtils.entityValueSelector(state, code));
